import React, { useState, useEffect } from "react";
import CardBox from "../../components/CardBox/index";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../tabPanel/TabPanel";
import classes from "./Profiles.module.scss";
import LegalTab from "./LegalTab";
import SubstantiveTab from "./SubstantiveTab";
import Button from "@material-ui/core/Button";
import { getAxios, putAxios } from "../../api/Axios";
import { profileApi } from "../../api/Urls";
import { useDispatch } from "react-redux";
import { isChangeProfileName, userSignOut } from "actions";
import { useSnackbar } from "notistack";
import toFarsiNumber from "util/toFarsiNumber";
import { toEnDigits } from "util/toEnDigits";
import { useTranslation } from "react-i18next";
import CircularProgress from "../../components/CircularProgress";

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const Profile = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [tabValue, setTabValue] = useState(0);
  const [defaultData, setDefaultData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [countryTelCode, setCountryTelCode] = useState("+98");
  const [userValues, setUserValues] = useState({
    firstName: "",
    lastName: "",
    nationalCode: "",
    companyName: "",
    registrationId: "",
    nationalId: "",
    legalEconomicCode: "",
    substantiveEconomicCode: "",
    phone: "",
    postalCode: "",
    address: "",
  });

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };

  const handleChangeInputs = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox" ? target.checked : toFarsiNumber(target.value);
    const name = target.name;
    setUserValues({ ...userValues, [name]: value });
  };

  const handleChangeInputsPhone = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setUserValues({ ...userValues, [name]: `+${value}` });
  };

  const handleChangeCountryTelCode = (e) => {
    setCountryTelCode(e.target.value);
  };

  useEffect(() => {
    setLoading(true);
    getAxios(profileApi)
      .then((res) => {
        setTabValue(res?.data?.Tenant?.profile?.is_company ? 1 : 0);
        setDefaultData(res?.data);
        handleDefaultData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
        setLoading(false);
        if (err?.response?.status === 401) {
          dispatch(userSignOut());
        }
      });
  }, []);

  const handleDefaultData = (data) => {
    const userData = data?.Tenant;
    setUserValues({
      firstName: userData?.first_name || "",
      lastName: userData?.last_name || "",
      nationalCode: userData?.profile?.national_id
        ? toFarsiNumber(userData?.profile?.national_id)
        : "",
      companyName: userData?.profile?.organization_name,
      registrationId: userData?.profile?.organization_register_number
        ? toFarsiNumber(userData?.profile?.organization_register_number)
        : "",
      nationalId: userData?.profile?.organization_national_id
        ? toFarsiNumber(userData?.profile?.organization_national_id)
        : "",
      legalEconomicCode: userData?.profile?.organization_tax_id
        ? toFarsiNumber(userData?.profile?.organization_tax_id)
        : "",
      substantiveEconomicCode: !userData?.profile?.is_company
        ? toFarsiNumber(userData?.profile?.national_id || "")
        : "",
      phone: userData?.profile?.phone
        ? toFarsiNumber(userData?.profile?.phone)
        : "",
      postalCode: userData?.profile?.postal_code
        ? toFarsiNumber(userData?.profile?.postal_code)
        : "",
      address: userData?.profile?.address,
    });
  };

  const handleSubmit = () => {
    let data = new FormData();
    data.append("nationality", defaultData.Tenant.profile.nationality);

    data.append("first_name", toEnDigits(userValues.firstName));
    data.append("last_name", toEnDigits(userValues.lastName));
    data.append("national_id", toEnDigits(userValues.nationalCode));
    data.append("phone", toEnDigits(userValues.phone));
    data.append("address", userValues.address);
    data.append(
      "is_authority_verified",
      defaultData.Tenant.profile.is_authority_verified
    );
    data.append("organization_name", userValues.companyName);
    data.append("is_company", defaultData.Tenant.profile.is_company);
    data.append("organization_national_id", toEnDigits(userValues.nationalId));
    data.append(
      "organization_register_number",
      toEnDigits(userValues.registrationId)
    );
    data.append(
      "organization_tax_id",
      toEnDigits(userValues.legalEconomicCode)
    );
    data.append("postal_code", toEnDigits(userValues.postalCode));
    data.append("is_company", toEnDigits(tabValue ? true : false));
    putAxios(`${profileApi}`, data)
      .then((data) => {
        enqueueSnackbar(data.data.message, {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
        });
        localStorage.setItem("firstname", userValues.firstName);
        localStorage.setItem("lastname", userValues.lastName);
        dispatch(isChangeProfileName());
        // handleDefaultData(data.data);
      })
      .catch((e) => {
        Object.values(e.response.data).map((item, index) => {
          enqueueSnackbar(item, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        });
      });
  };

  return (
    <div
      className={`row animated slideInUpTiny animation-duration-3 ${
        i18n.dir() === "rtl" ? "uptin-table" : "uptin-table-ltr"
      }`}
    >
      <CardBox styleName="col-12" cardStyle="p-0" headerOutside>
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={tabValue}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              // variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label={t("profile.substantive")} {...a11yProps(0)} />
              <Tab label={t("profile.legal")} {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          {loading ? (
            <CircularProgress />
          ) : (
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={tabValue}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={tabValue} index={0} dir={theme.direction}>
                <SubstantiveTab
                  handleChangeInputs={handleChangeInputs}
                  handleChangeInputsPhone={handleChangeInputsPhone}
                  userValues={userValues}
                  countryTelCode={countryTelCode}
                  handleChangeCountryTelCode={handleChangeCountryTelCode}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={1} dir={theme.direction}>
                <LegalTab
                  handleChangeInputs={handleChangeInputs}
                  handleChangeInputsPhone={handleChangeInputsPhone}
                  userValues={userValues}
                  countryTelCode={countryTelCode}
                  handleChangeCountryTelCode={handleChangeCountryTelCode}
                />
              </TabPanel>
            </SwipeableViews>
          )}
          <div className={classes.buttonRoot}>
            <Button
              variant="contained"
              className="btn btn-primary jr-btn-uptin"
              onClick={handleSubmit}
            >
              {t("profile.save")}
            </Button>
          </div>
        </div>
      </CardBox>
    </div>
  );
};

export default Profile;
